import { createContext, useContext } from "react";

// Carries the open claim's Needs-Attention badges to every tab's TabHeader
// without prop-drilling through all ~11 tab components. ClaimWorkspace fetches
// once and provides { claimId, badges }; TabHeader renders them (via TabBadges)
// in its header line. Absent (null) outside the claim workspace — e.g. the
// search page also uses TabHeader — so those headers simply show no badges.
export const ClaimBadgesContext = createContext(null);

export const useClaimBadges = () => useContext(ClaimBadgesContext);
